import { Link } from "react-router";
import logoSIADark from "@assets/events-awards/logo-sia-dark.png";
import Container from "@components/Container/Container";
import Column from "@components/Grid/Column";
import Row from "@components/Grid/Row";
import { EVENTS_AWARDS_SIA_PATH } from "@events-awards/utils/constants";
import { useWindowSize } from "@hooks/useWindowSize";

import { SIA_FOOTER_MENU } from "./SIAConstants";

type FooterLinksType = {
  /** label is used to display text for footer navigation items */
  label: string;
  /** link is used for the navigation of the footer items */
  link: string;
};

/**
 * Component to display footer in SIA pages
 */
const SIAFooter = () => {
  const { isScreenLG } = useWindowSize();
  const aboutText =
    "The Sustainability Impact Awards (SI Awards), launched on 1 February 2023, is jointly presented by The Business Times and UOB, with the Centre for Governance and Sustainability (CGS) at the National University of Singapore Business School as the knowledge partner.";

  const renderMenuLinks = (items: FooterLinksType[]) =>
    items.map((item) => (
      <Link
        to={`${item.link}?ref=footer`}
        key={item.label}
        className="text-left text-sm text-white hover:text-white/75"
        reloadDocument
      >
        {item.label}
      </Link>
    ));

  return (
    <footer
      data-testid="sia-footer-component"
      className="mb-4 bg-gray-850 py-8 font-public-sans"
    >
      <Container rootClassName="flex flex-row justify-center text-white">
        {isScreenLG ? (
          <Row rootClassName="w-full lg:flex text-center my-8">
            <Column>
              <Link to={EVENTS_AWARDS_SIA_PATH}>
                <img
                  src={logoSIADark}
                  alt="Sustainability Impact Awards logo"
                  width={200}
                />
              </Link>
            </Column>

            <Column rootClassName="flex-1">
              <h3 className="mb-4 text-left font-poppins text-base font-semibold">
                About Us
              </h3>

              <p className="text-left text-white">{aboutText}</p>
            </Column>

            <Column>
              <p className="mb-4 text-left font-semibold">Sections</p>

              <Row rootClassName="my-2 px-3">
                <Column rootClassName="space-y-2 flex flex-col px-0">
                  {renderMenuLinks(SIA_FOOTER_MENU.slice(0, 3))}
                </Column>

                <Column rootClassName="space-y-2 flex flex-col mt-0">
                  {renderMenuLinks(SIA_FOOTER_MENU.slice(3, 5))}
                </Column>
              </Row>
            </Column>

            <Column>
              <p className="mb-4 text-left font-semibold">Quick Links</p>

              <div className="flex flex-col space-y-2 px-0">
                {renderMenuLinks(SIA_FOOTER_MENU.slice(5, 8))}
              </div>
            </Column>
          </Row>
        ) : (
          <div className="w-full text-center">
            <div className="mb-6 flex w-full flex-col items-center justify-center">
              <Link to={EVENTS_AWARDS_SIA_PATH}>
                <img
                  src={logoSIADark}
                  alt="Sustainability Impact Awards logo"
                  width={200}
                />
              </Link>
            </div>

            <div>
              <h3 className="mb-4 text-left font-poppins text-lg font-semibold">
                About Us
              </h3>

              <p className="text-left text-sm text-white">{aboutText}</p>
            </div>

            <Row rootClassName="w-full -mx-0 mt-6">
              <Column rootClassName="w-1/2">
                <h3 className="mb-4 text-left font-public-sans text-lg font-semibold">
                  Sections
                </h3>

                <div className="flex flex-col px-0">
                  {renderMenuLinks(SIA_FOOTER_MENU.slice(0, 5))}
                </div>
              </Column>

              <Column rootClassName="w-1/2">
                <h3 className="mb-4 text-left font-public-sans text-lg font-semibold">
                  Quick Links
                </h3>

                <div className="flex flex-col px-0">
                  {renderMenuLinks(SIA_FOOTER_MENU.slice(5, 8))}
                </div>
              </Column>
            </Row>
          </div>
        )}
      </Container>
    </footer>
  );
};

export default SIAFooter;
